var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendaric = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.7692 12.5769H17.6154V20.8846",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7692 20.8846H19.4615",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.84615 5.19232C2.35652 5.19232 1.88695 5.38683 1.54073 5.73305C1.1945 6.07927 1 6.54885 1 7.03848V23.6539C1 24.1435 1.1945 24.6131 1.54073 24.9593C1.88695 25.3055 2.35652 25.5 2.84615 25.5H23.1538C23.6435 25.5 24.1131 25.3055 24.4593 24.9593C24.8055 24.6131 25 24.1435 25 23.6539V7.03848C25 6.54885 24.8055 6.07927 24.4593 5.73305C24.1131 5.38683 23.6435 5.19232 23.1538 5.19232H19.4615",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.53845 1.5V8.88462",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M19.4615 1.5V8.88462",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.53845 5.19232H15.7692",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M6.53845 12.5769H11.1538L8.38461 16.2692C8.38461 16.2692 11.1538 16.2692 11.1538 18.1154C11.2059 18.4912 11.1702 18.874 11.0495 19.2338C10.9287 19.5935 10.7262 19.9204 10.4579 20.1887C10.1896 20.457 9.86275 20.6595 9.50302 20.7802C9.14329 20.901 8.76047 20.9367 8.38461 20.8846H6.53845",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendaric);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendaric.40a354883800340f05af07ad31dcf4be.svg";